module.exports = __webpack_public_path__ + "img/id.0306b2ab.svg";